"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTextInput = void 0;
const classnames_1 = __importDefault(require("classnames"));
const nanoid_1 = require("nanoid");
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const TextField_module_css_1 = __importDefault(require("./TextField.module.css"));
function createTextInput(element, defaultProps) {
    const Input = react_1.default.forwardRef(({ hint, label, error, ...props }, ref) => {
        var _a;
        const intl = react_intl_1.useIntl();
        const id = react_1.useMemo(() => { var _a; return (_a = props.id) !== null && _a !== void 0 ? _a : nanoid_1.nanoid(); }, [props.id]);
        return (react_1.default.createElement("div", { className: classnames_1.default(TextField_module_css_1.default.wrapper, {
                [TextField_module_css_1.default.error]: error,
                [TextField_module_css_1.default.disabled]: props.disabled,
                [TextField_module_css_1.default.readOnly]: props.readOnly
            }) },
            react_1.default.createElement("label", { htmlFor: id, className: classnames_1.default(TextField_module_css_1.default.label) },
                label,
                props.required && '*'),
            react_1.default.createElement(element, {
                ...defaultProps,
                ...props,
                id,
                ref: ref,
                readOnly: props.readOnly,
                required: props.required,
                disabled: props.disabled || props.readOnly,
                placeholder: (_a = props.placeholder) !== null && _a !== void 0 ? _a : intl.formatMessage({ id: '@lemonone/components/TextArea:placeholder' }),
                className: classnames_1.default(props.className, TextField_module_css_1.default.input)
            }),
            hint && react_1.default.createElement("span", { className: TextField_module_css_1.default.hint }, hint)));
    });
    return Input;
}
exports.createTextInput = createTextInput;
//# sourceMappingURL=createTextField.js.map